import React from 'react';
import getDealerPageProps, { PAGE_TYPES } from 'shared/routes/dealer';
import { DEALER_TABS } from 'shared/constants/navigation';
import API from 'shared/constants/api';
import Dealer from '../Dealer';
import Layout from '../../../components/Layout';
import LINKS from '../../../constants/navigation';

const PER_PAGE = 20;

async function action(params) {
  const pageProps = await getDealerPageProps(params, PAGE_TYPES.NEWS);

  if (!pageProps) {
    return null;
  }

  const {
    url,
    query,
    transportType,
    dealer,
    carsListTypes,
    dealersTypes,
    title,
    description,
    locale,
  } = pageProps;

  const { page } = query;
  const currentPage = page ? parseFloat(page) : 1;
  const news = await params
    .fetch(API.JOURNAL.LIST({ agency: dealer.id, language: locale, page: currentPage }))
    .then(r => r.json());

  return {
    chunks: ['dealer'],
    title,
    description,
    component: (
      <Layout navLinks={LINKS.SEARCH.avto} currentRoute={url}>
        <Dealer
          transportType={transportType}
          dealerInfo={dealer}
          tab={DEALER_TABS.BLOG}
          carsListTypes={carsListTypes}
          dealersTypes={dealersTypes}
          url={url}
          query={query}
          news={news.results}
          newsPage={parseInt(query.page || 1, 10)}
          newsPageCount={Math.ceil(news.count / PER_PAGE)}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/blog/index.js